<template>
  <UiSnackbar
    :modelValue="snackbar.visible"
    :color="snackbar.color"
    @update:modelValue="onUpdate"
  >
    {{ snackbar.message }}
  </UiSnackbar>
</template>
<script setup lang="ts">
import { watch } from 'vue'

import UiSnackbar from '@/shared/components/ui/UiSnackbar.vue'

import { useSnackbarStore } from './snackbar.store'

const snackbar = useSnackbarStore()

let timeoutId: ReturnType<typeof setTimeout> | null = null

watch(
  () => [snackbar.visible, snackbar.message, snackbar.token] as const,
  ([newVal], [_oldVal]) => {
    if (timeoutId) {
      clearTimeout(timeoutId)
      timeoutId = null
    }
    if (newVal) {
      // (Re)start the auto-hide timer whenever the snackbar becomes visible
      // OR a new message is shown while already visible — otherwise a second
      // notification arriving during the first one's 3s window would inherit
      // the stale timer and disappear too early.
      timeoutId = setTimeout(() => {
        snackbar.hide()
      }, snackbar.durationMs)
    }
  },
)

function onUpdate(val: boolean) {
  if (!val) {
    snackbar.hide()
  }
}
</script>
